import { getDataFromScript } from '../utils/helpers';

export default class PurchasesSearch {
  constructor() {
    this.table = document.getElementById('grid_purchases');
    this.purchases = getDataFromScript('purchase-table-data') || null;
    this.rows = this.table?.querySelectorAll('tbody tr');
    this.picker = document.getElementById('topFilter');

    if ( this.table && this.purchases ) {
      this.rows.forEach(( tr, key ) => {
        if (!tr.classList.contains('no-data-row')) {
          tr.setAttribute('data-purchase-status', this.purchases[key].status);
        }
      });

      this.filterDataTable();
    }
  }

  filterByStatus(purchases, value, key) {
    return purchases.filter( purchase => purchase[key] === value || !value);
  }

  filterDataTable() {
    let purchasesFiltered = this.purchases;
    purchasesFiltered = this.filterByStatus(purchasesFiltered, this.picker.value, 'status');
    const statusToShow = purchasesFiltered.map( purchase => purchase.status );
    this.rows.forEach(( tr ) => {
      if (tr.hasAttribute('data-purchase-status') && statusToShow.indexOf(tr.getAttribute('data-purchase-status')) === -1) {
        tr.classList.add('d-none');
      } else {
        tr.classList.remove('d-none');
      }
    });
  }
}
